import { Button, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { Header } from '@/components/Header/Header';
import { Icon } from '@/components/Icon/Icon';
import { IconCell } from '@/components/Icon/IconCell';

import { useAppDispatch } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { signOut } from '@/redux/auth/actions';

import { getDataTestId } from '@/utils/browser';

import {
  Container,
  Content,
  IllustrationContainer,
} from './AccountRejected.styled';

export default function AccountRejectedScreen() {
  const { t } = useTranslate();
  const dispatch = useAppDispatch();
  const handleSignOut = () => dispatch(signOut());

  return (
    <Container>
      <Content {...getDataTestId('account-rejected-content')}>
        <Header />
        <IllustrationContainer>
          <IconCell
            name={'block'}
            size={164}
            iconSize={82}
            color={(theme: Theme) => theme.palette.error.main}
            bgColor={(theme: Theme) => theme.palette.red[200]}
          />
        </IllustrationContainer>
        <Typography variant="h4" textAlign="center" mb={1}>
          {t('accountRejected.title')}
        </Typography>
        <Typography variant="body2" textAlign="center" mb={4}>
          {t('accountRejected.body')}
        </Typography>
        <Button
          variant="outlined"
          startIcon={<Icon name="sign-out" />}
          onClick={handleSignOut}
          {...getDataTestId('account-rejected-button-logout')}
        >
          {t('accountRejected.button.logout')}
        </Button>
      </Content>
    </Container>
  );
}
